import PageShell from '../../components/layout/PageShell';
import MasterDataPage from '../config/MasterDataPage';

export default function PromosCouponsPage() {
  return (
    <PageShell>
      <MasterDataPage
        embedded
        catalogScope="common"
        singleTypeMode={{ groupKey: 'app_promotions', typeKey: 'app_promo_coupons' }}
        pageTitle="Promos & Coupons"
        pageSubtitle="Customer app discount codes"
      />
    </PageShell>
  );
}
